import {Injectable} from '@angular/core';

import {
    HttpEvent,
    HttpInterceptor,
    HttpHandler,
    HttpRequest,
    HttpResponse
} from '@angular/common/http';

import {Observable} from 'rxjs';
import {tap} from 'rxjs/internal/operators/tap';
import {of} from 'rxjs/internal/observable/of';

import {environment} from '../../../environments/environment';

import {CacheCollectionService} from '../services';

@Injectable()
export class CacheInterceptor implements HttpInterceptor {
    private readonly cacheResponseHeader: string;

    constructor(protected cacheCollectionService: CacheCollectionService) {
        this.cacheResponseHeader = environment.customCacheResponseHeader;
    }

    private getCachedResponse(url: string): Observable<HttpResponse<any>> {
        const cachedItem = this.cacheCollectionService.getItem(url);

        const httpResponse = new HttpResponse({
            body: cachedItem.data,
            status: 200,
            statusText: 'OK',
            url
        });

        return of(httpResponse);
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const requestUrl = request.urlWithParams;

        if (this.cacheCollectionService.hasItem(requestUrl)) {
            return this.getCachedResponse(requestUrl);
        }

        let cachedResponse = false;

        if (request.headers.has(this.cacheResponseHeader)) {
            cachedResponse = true;

            const httpHeaders = request.headers
                .delete(this.cacheResponseHeader);

            request = request.clone({
                headers: httpHeaders
            });
        }

        return next.handle(request)
            .pipe(
                tap(event => {
                    if (
                        (event instanceof HttpResponse) &&
                        (event.body !== null) &&
                        cachedResponse
                    ) {
                        this.cacheCollectionService.addItem(requestUrl, event.body);
                    }
                })
            );
    }
}
